import { Component } from '@angular/core';

@Component({
  selector: 'app-system-footer',
  standalone: false,
  templateUrl: './system-footer.component.html',
  styleUrl: './system-footer.component.scss'
})
export class SystemFooterComponent {
  currentYear: number = new Date().getFullYear();
}
